export const BASE_RAD = 25;
export const BASE_ANOMALY_RAD = 12;
export const BASE_DEATHSTAR_RAD = 8;
export const BASE_DEATHBEAM_RAD = 8;

export const ASTEROID_RAD = 25;
export const ASTEROID_RAD_JITTER = 10;

export const BLACK_HOLE_RAD = 20;

export const JET_BLACK_HOLE_RAD = 8;

export const JOVIAN_RAD = 160;
export const JOVIAN_RAD_JITTER = 90;

export const NEUTRON_STAR_RAD = 9;
export const NEUTRON_STAR_RAD_JITTER = 3;

export const PLANET_RAD = 50;
export const PLANET_RAD_JITTER = 20;

export const RED_GIANT_RAD = 300;
export const RED_GIANT_RAD_JITTER = 50;

export const STAR_RAD = 240;
export const STAR_RAD_JITTER = 60;

export const SUPERGIANT_RAD = 2000;
export const SUPERGIANT_RAD_JITTER = 1000;

export const WHITE_DWARF_RAD = 9;
export const WHITE_DWARF_RAD_JITTER = 3;

export const WHITE_HOLE_RAD = 9;
export const WHITE_HOLE_RAD_JITTER = 3;

export const WORMHOLE_RAD = 55;
export const WORMHOLE_RAD_JITTER = 25;